<template>
  <div v-if="data" class="inspection-report-list">
    <div class="panel panel-default border-panel card-view">
      <div class="panel-wrapper collapse in">
        <div class="panel-body">
          <div class="table-wrap">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <td style="border: none !important" class="page-header-space">
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr style="width: 100%">
                    <td style="width: 10%">
                      <span>{{$t(`app.inspections.summary.staments`)}}</span>
                    </td>
                    <td style="width: 10%;text-align: right;">
                      <span class="title">{{$t(`app.inspections.summary.all_count`)}}</span>
                      <span class="title">{{$t(`app.inspections.summary.checked_count`)}}</span>
                      <span class="title">{{$t(`app.inspections.summary.matched_count`)}}</span>
                      <span class="title">{{$t(`app.inspections.summary.dismatched_count`)}}</span>
                    </td>
                    <td style="width: 10%">
                      <span>{{data.summary.inspection_statements_count}} db</span>
                      <span>{{data.summary.inspection_statements_count - data.summary.unknown}} db</span>
                      <span>{{data.summary.matched}} db</span>
                      <span>{{data.summary.dismatched}} db</span>
                    </td>
                  </tr>
                  <tr style="width: 100%">
                    <td style="width: 10%">
                      <span>{{$t(`app.inspections.summary.locations`)}}</span>
                    </td>
                    <td class="report-list" style="width: 10%">
                      <ul v-if="data.summary.locations.length > 0">
                        <li
                          v-for="(location,index) in data.summary.locations"
                          :key="index"
                        >{{location}}</li>
                      </ul>
                      <span v-if="data.summary.locations.length === 0">{{$t('app.noValue')}}</span>
                    </td>
                    <td style="width: 10%"></td>
                  </tr>
                  <tr style="width: 100%">
                    <td style="width: 10%">
                      <span>{{$t(`app.inspections.summary.categories`)}}</span>
                    </td>
                    <td class="report-list" style="width: 10%">
                      <ul v-if="data.summary.categories.length > 0">
                        <li
                          v-for="(category,index) in data.summary.categories"
                          :key="index"
                        >{{category}}</li>
                      </ul>
                      <span v-if="data.summary.categories.length === 0">{{$t('app.noValue')}}</span>
                    </td>
                    <td style="width: 10%"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatementAsset from '@/components/modules/inspections/StatementAsset';

export default {
  name: 'InspectionReportSummary',
  components: {
    'statement-asset': StatementAsset,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editable: true,
    };
  },
  created() {
    if (this.$route.name === 'InspectionReportScreen') {
      this.editable = false;
    }
  },
  computed: {},
  mounted() {},
  methods: {
    updateResult(row) {
      this.$emit('updateResult', row);
    },
    updateMemoClicked(row, memo) {
      this.$emit('updateMemoClicked', {
        memo,
        inspectionStatementId: row.id,
      });
    },
    removeAssetClicked(payload) {
      this.data.forEach((x) => {
        if (x.id === payload.inspectionStatementId) {
          let deletAbleIndex;
          x.statement.assets.forEach((asset, index) => {
            if (asset.id === payload.id) {
              deletAbleIndex = index;
            }
          });
          x.statement.assets.splice(deletAbleIndex, 1);
        }
      });
    },
    navigateToTask() {
      this.$router.push({ name: 'TasksScreen' });
    },
    locationList(data) {
      const mappedNames = data.map(item => item.name);
      return mappedNames.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
.inspection-report-list {
  @media print {
    .table-wrap {
      margin-top: 0px !important;
    }
  }
  .page-header-space {
    height: 0;
    @media print {
      height: 20px;
    }
  }
  .table-wrap {
    margin-top: 10px;
    @media print {
      margin-top: 40px;
    }
  }
  .action-button {
    cursor: pointer;
  }

  .base-link {
    font-weight: 500;
  }

  .table-row:hover {
    background-color: rgba(163, 163, 163, 0.05) !important;
  }

  .table-row-mismatched {
    background-color: rgba(218, 69, 69, 0.082);
  }

  table {
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    span {
      display: block;
    }
    i.active {
      color: var(--main-color);
    }

    i.inactive {
      color: #bcbccb;
    }

    [class*="ti-"] {
      font-size: 20px !important;
    }
  }
  .array-span {
    background: var(--main-color);
    border-radius: 4px;
    color: #ffffff;
    font-size: 11px;
    padding: 3px 4px 3px 4px;
    margin-right: 10px;
    float: left;
    text-align: center;
  }

  .empty-section {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-top: 40px;
  }

  .statement {
    margin-bottom: 30px;
  }

  .matched {
    color: green;
  }

  .mismatched {
    color: red;
  }

  .unknown {
    color: var(--main-color);
  }

  .icon {
    float: right !important;
    clear: none !important;
  }

  .title {
    font-weight: bold;
  }

  .subTitle {
    float: left;
    font-weight: bold;
    margin-right: 5px;
  }

  .with-margin {
    margin-top: 10px;
  }

  ul {
    list-style: disc;
  }

  .base-td {
    vertical-align: baseline;
  }

  .task-type {
    background: #ff6565;
    border-radius: 14px;
    color: #ffffff;
    font-size: 11px;
    padding: 4px 8px 4px 8px;
    margin-left: 5px;
    // float: left;
    // float: right;
  }

  .task-name {
    display: -webkit-inline-box;
    cursor: pointer;
  }

  @media print {
    .icon {
      display: none;
    }
    .table-responsive {
      overflow: hidden;
    }

    .report-list {
      padding-left: 30px;
    }
    table {
      table-layout: fixed;
      border-collapse: collapse;
      width: 100%;
      td,
      th {
        border: 1px solid #eee !important;
      }

      span {
        display: block;
        word-wrap: break-word;
        white-space: normal;
      }
    }
  }
}

#inspection-header {
  @media print {
    // page-break-after: always;
  }
  h3,
  h6 {
    @media print {
      // display: inline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/InspectionReportSummary.vue